import { trackConfig, type IFramework } from '@/framework';
import { LayerType, VectorType, type ILayerProps, type IVectorLayerProps } from '@/version-types';
import { pushHistory, updateLayer } from '../utils';

export interface IBlur {
    /**
     * 设置模糊特
     * @param layerID - 图层 id
     * @param value - 模糊程度
     * @param options - 可选；配置项；`options.writeHistory` - 是否写入历史记录
     */
    setBlur(layerID: string, value: number, options?: { writeHistory: boolean }): ILayerProps | void;
}

export class Blur implements IBlur {
    private prevLayer: ILayerProps | null = null;

    constructor(private framework: IFramework) {}

    setBlur(layerID: string, value: number, options = { writeHistory: true }) {
        const prevLayer = (() => {
            if (this.prevLayer) return this.prevLayer;
            this.prevLayer = this.framework.getLayer(layerID, true);
            return this.prevLayer;
        })();

        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const prevLayerData = prevLayer.data as IVectorLayerProps;
        const { vectorType } = prevLayerData;

        if (vectorType === VectorType.Graph) return;

        const { writeHistory } = options;

        if (writeHistory) {
            const nextLayer = this.framework.getLayer(layerID, true);

            pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.VECTOR_LAYER].blur);
            this.prevLayer = null;

            return nextLayer;
        }

        const nextLayerData: IVectorLayerProps = { ...prevLayerData, blur: value };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        updateLayer(this.framework, nextLayer);

        return nextLayer;
    }
}
